import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class ClaimsService {
  getClaimInvoices(params) {
    return securedAxiosInstance.get("/claims/invoices", { params: toSnakeCase(params) });
  }

  fetchIndex(params) {
    return securedAxiosInstance.get("/claims", { params: toSnakeCase(params) });
  }

  fetch(claimFriendlyId, includes = []) {
    return securedAxiosInstance.get(`/claims/${claimFriendlyId}`, { params: { includes } });
  }

  uploadQuotation(claimId, formData) {
    return securedAxiosInstance.patch(`/claims/${claimId}/upload_quotation`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  declareIrreparable(claimId, formData) {
    return securedAxiosInstance.patch(`/claims/${claimId}/declare_irreparable`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  extractCostItems(claimId, file) {
    const formData = new FormData();
    formData.append("file", file);
    return securedAxiosInstance.post(`/claims/${claimId}/extract_cost_items`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  uploadInvoice(claimId, formData) {
    return securedAxiosInstance.patch(`/claims/${claimId}/upload_invoice`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}

export default new ClaimsService();
